export default __webpack_public_path__ + "static/media/laravel -logo.952e5b7c.svg";